import { render, staticRenderFns } from "./BargainDetail.vue?vue&type=template&id=0fcb1352&scoped=true&"
import script from "./BargainDetail.vue?vue&type=script&lang=js&"
export * from "./BargainDetail.vue?vue&type=script&lang=js&"
import style0 from "./BargainDetail.vue?vue&type=style&index=0&id=0fcb1352&prod&lang=scss&scoped=true&"
import style1 from "./BargainDetail.vue?vue&type=style&index=1&id=0fcb1352&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb1352",
  null
  
)

export default component.exports